import React from "react";
import "../styles/Experience.css";

const Experience = () => {
  return (
    <div>
      <h2>Experience</h2>
      <div className="skills">
        <div className="skillIcon">
          <img src="Images/html.png" alt="" />
        </div>
        <div className="skillIcon">
          <img src="Images/sass.png" alt="" />
        </div>
        <div className="skillIcon">
          <img src="Images/javascript.png" alt="" />
        </div>
        <div className="skillIcon">
          <img src="Images/shopify.png" alt="" />
        </div>
        <div className="skillIcon">
          <img src="Images/wordpress.png" alt="" />
        </div>
        <div className="skillIcon">
          <img src="Images/cc.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Experience;
